import { DOMAIN } from "@/plugins/consts";

export default {
  user_profile: 'mover_app_user_profile',

  get () {
    return $cookies.get(this.user_profile);
  },

  save (data) {
    const filteredUser = {
      name: data.company ? data.company.name : `${data.user.first_name} ${data.user.last_name}`,
      email: data.user.email,
      image: data.main_branch ? data.main_branch.image : data.user.image
    };

    console.log(data);

    $cookies.set(this.user_profile, filteredUser, 60 * 60 * 24 * 7, '/', DOMAIN);
    return localStorage.setItem(this.user_profile, JSON.stringify(filteredUser));
  },

  delete () {
    $cookies.remove(this.user_profile, '/', DOMAIN);
    return localStorage.removeItem(this.user_profile);
  }
}
